<form (ngSubmit)="onSubmit()" [formGroup]="form">
    <div class="row">
        <div class="form-group col-md-6">
            <validation [formGroup]="form" controlName="bankName" displayName="Bank">
                <label for="bankName">Bank Name:</label>
                <p-select (onChange)="updateBank()"
                          [options]="banks"
                          class="form-control"
                          formControlName="bankName"
                          id="bankName"
                          optionLabel="bankName"
                          optionValue="bankName"
                          placeholder="Select your bank"/>
            </validation>
        </div>

        <div class="form-group col-md-6">
            <validation [formGroup]="form" controlName="bankAccountNumber" displayName="Account number">
                <label for="bankAccountNumber">Account Number:</label>
                <input class="form-control"
                       formControlName="bankAccountNumber"
                       id="bankAccountNumber"
                       mask="0*"
                       maxlength="30"
                       pTooltip="Any updates to your bank account number will require an account verification (AVS) check to be completed."
                       type="text"/>
            </validation>
        </div>

        <div class="form-group col-md-6">
            <validation [formGroup]="form" controlName="bankBranch" displayName="Branch number">
                <label for="bankBranch">Branch:</label>
                <input class="form-control"
                       formControlName="bankBranch"
                       id="bankBranch"
                       mask="0*"
                       maxlength="10"
                       pTooltip="The bank branch number. Will be automatically populated with the universal branch number of the bank chosen"
                       type="text"/>
            </validation>
        </div>
    </div>

    <div class="row justify-content-center justify-content-sm-center">
        <div class="btn-group mt-5">
            <button (click)="emitGoToPrevious()" class="navy-btn mr-3" type="button">
                <i class="fa fa-chevron-left fas"></i> &nbsp;Back
            </button>
            <button class="navy-btn" type="submit">Next <i class="fa fa-chevron-right fas"></i>
            </button>
        </div>
    </div>
</form>
<pre [hidden]="!isDeveloperMode()"><code>{{ getAllErrors(form) | json }}</code></pre>
